import { render, staticRenderFns } from "./MainButtonExpand.vue?vue&type=template&id=02c390a0&scoped=true"
import script from "./MainButtonExpand.vue?vue&type=script&lang=js"
export * from "./MainButtonExpand.vue?vue&type=script&lang=js"
import style0 from "./MainButtonExpand.vue?vue&type=style&index=0&id=02c390a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c390a0",
  null
  
)

export default component.exports